export default __webpack_public_path__ + "static/media/38.aae7ffd1.jpg";